import {
  Button,
  Drawer,
  Hairline,
  Input,
  Label,
  Radio,
  Select,
} from "@components";
import { useState } from "react";
import { ForEach, If } from "shared/components/control-statements";
import styles from "styles/CashbackProgram.module.scss";

export default function LimitOperationsCashback({ visible, onClose }) {
  const [limit, setLimit] = useState(0);
  const [notify, setNotify] = useState(false);
  const [email, setEmail] = useState("");
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(false);

  const isEmail = email.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/);

  const save = async () => {
    setLoading(true);
  };

  return (
    <Drawer
      visible={visible}
      onClose={onClose}
      title="Limite de operações"
      withoutTransition
    >
      <Label>Defina o limite diário de operações</Label>
      <Select
        options={[
          { value: 0, label: "Sem limite" },
          { value: 2, label: "2" },
          { value: 3, label: "3" },
          { value: 4, label: "4" },
          { value: 5, label: "5" },
        ]}
        value={limit}
        onChange={(e) => setLimit(e.target.value)}
      />
      <Hairline className="mt-15 mb-15" />
      <Label>
        Gostaria de ativar um alerta em casos que o cliente excede o limite?
      </Label>
      <Radio
        family="notify"
        checked={notify}
        value={false}
        onChange={() => setNotify(false)}
      >
        Não
      </Radio>
      <Radio
        family="notify"
        className="mt-15"
        value={true}
        checked={notify}
        onChange={() => setNotify(true)}
      >
        Sim, quero ativar um alerta
      </Radio>

      <If cond={notify}>
        <div className={styles.emails}>
          <p className={styles.label}>
            Insira o(s) e-mail(s) que serão avisados:
          </p>
          <div className="d-flex align-center">
            <Input
              className="flex-1"
              placeholder=""
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button
              design="default-icon-3"
              className="ml-10"
              disabled={!email || !isEmail}
              onClick={() => {
                setEmails((prev) => [...prev, email]);
                setEmail("");
              }}
            >
              <i className="far fa-plus" />
            </Button>
          </div>
          <If cond={emails.length > 0}>
            <div className={styles.contains}>
              <ForEach
                items={emails}
                render={(email, index) => (
                  <li key={index}>
                    <span>{email}</span>
                    <div
                      className={styles.remove}
                      onClick={() =>
                        setEmails(emails.filter((_, i) => i !== index))
                      }
                    >
                      <i className="fas fa-times" />
                    </div>
                  </li>
                )}
              />
            </div>
          </If>
        </div>
      </If>

      <div className={styles.footer}>
        <Button
          design="primary"
          className="w-100"
          disabled={(notify && emails.length === 0) || loading}
          loading={loading}
          onClick={save}
        >
          Salvar
        </Button>
      </div>
    </Drawer>
  );
}
